// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__p3xmg","footer":"ChangeClinic_footer__1h4VC"};